import {
  ChangeEventHandler,
  FocusEventHandler,
  InputHTMLAttributes,
  useState
} from 'react'

import { EyerBlockSvg, EyerPasswordSvg } from '../../assets/icons/svgComponents'

import * as S from './styles'

type InputTypes = InputHTMLAttributes<HTMLInputElement>

type InputProps = {
  topEyer?: string
  topEyerBlock?: string
  label?: string
  labelColor?: string
  name: string
  placeholder?: string
  hasTestInput?: boolean
  error?: string
  value?: string | number
  onChange?: ChangeEventHandler | undefined
  onBlur?: FocusEventHandler | undefined
} & InputTypes

const InputPassword = ({
  topEyer,
  topEyerBlock,
  label,
  labelColor,
  hasTestInput = false,
  name,
  value,
  onChange,
  error,
  onBlur,
  ...props
}: InputProps) => {
  const [visible, setVisible] = useState(false)

  return (
    <S.Wrapper
      hasTestInput={hasTestInput}
      topEyer={topEyer}
      topEyerBlock={topEyerBlock}
    >
      <label style={{ color: labelColor }} htmlFor={name}>
        {label}
      </label>
      <input
        type={visible ? 'text' : 'password'}
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        {...props}
      />
      {visible ? (
        <EyerBlockSvg
          className="icon-eyer-block"
          onClick={() => setVisible(!visible)}
        />
      ) : (
        <EyerPasswordSvg
          className="icon-eyer"
          onClick={() => setVisible(!visible)}
        />
      )}
      {error && <p className="error">{error}</p>}
    </S.Wrapper>
  )
}

export default InputPassword
